import { render, staticRenderFns } from "./alterarDatasRomaneio.vue?vue&type=template&id=b6a37462&scoped=true&"
import script from "./alterarDatasRomaneio.vue?vue&type=script&lang=js&"
export * from "./alterarDatasRomaneio.vue?vue&type=script&lang=js&"
import style0 from "./alterarDatasRomaneio.vue?vue&type=style&index=0&id=b6a37462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a37462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VFlex,VForm,VLayout,VMenu,VSpacer,VSwitch,VTextField})
